/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuildFileDto } from '../../models/build-file-dto';

export interface BuildFileControllerCreate$Params {
      body: {
'file'?: Blob;
}
}

export function buildFileControllerCreate(http: HttpClient, rootUrl: string, params: BuildFileControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BuildFileDto>> {
  const rb = new RequestBuilder(rootUrl, buildFileControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuildFileDto>;
    })
  );
}

buildFileControllerCreate.PATH = '/api/build-file';
